import { cn } from '../../utils/classNames';
import useXInputValue from '../../hooks/useXInputValue';

const labelClasses = 'block mb-2 text-content font-sans';

const wrapperClasses = 'w-full';

const inputBaseClasses = `
  w-full h-10 px-3 py-1.5
  font-sans text-base text-content
  bg-white border border-border rounded-md
  transition-colors
  focus:outline-none focus:ring-2 focus:ring-primary-ring focus:border-primary
  disabled:opacity-60 disabled:cursor-not-allowed
`;

const errorClasses = 'block mt-1 ml-1 text-sm text-danger';

const XInput = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  disabled = false,
  className,
  error,
  type = 'text',
  defaultValue = '',
  autocomplete = true,
  ...props
}) => {
  const { displayValue, handleChange } = useXInputValue({
    type,
    name,
    value,
    defaultValue,
    onChange,
  });

  return (
    <>
      {label && <label className={labelClasses}>{label}</label>}
      <div className={wrapperClasses}>
        <input
          type={type}
          name={name}
          value={displayValue}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autocomplete ? 'on' : 'off'}
          className={cn(inputBaseClasses, className)}
          {...props}
        />
        {error && <span className={errorClasses}>{error}</span>}
      </div>
    </>
  );
};

export default XInput;
